import { Component, OnDestroy, OnInit } from '@angular/core';
import { catchError, Subscription, tap } from 'rxjs';
import { ActivatedRoute, Params, RouterLink } from '@angular/router';
import { AuthService } from '../auth.service';
import { FlowComponent } from '../controls/flow/flow.component';
import { HttpErrorResponse } from '@angular/common/http';
import { RegistrationFlow, UpdateRegistrationFlowBody } from '../../../sdk/kratos';
import { MiraLogoComponent } from '../../ui/mira-logo/mira-logo.component';
import { ThemeToggleComponent } from '../../ui/theme-toggle/theme-toggle.component';

@Component({
    selector: 'app-registration',
    imports: [
      MiraLogoComponent,
      ThemeToggleComponent,
        FlowComponent,
        RouterLink
    ],
    templateUrl: './registration.component.html',
    styleUrl: './registration.component.less'
})
export class RegistrationComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  flow?: RegistrationFlow;
  loginUrlQueryParams: Params = {};

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService) {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    if (this.flow) {
      return;
    }
    const queryParamMap = this.activatedRoute.snapshot.queryParamMap;
    const flowId = queryParamMap.get('flow') || undefined;
    const returnTo = queryParamMap.get('return_to') || undefined;
    const loginChallenge = queryParamMap.get('login_challenge') || undefined;
    this.subscription.add(
      this.authService.createOrGetRegistrationFlow(flowId, returnTo, loginChallenge)
        .pipe(tap((data) => {
          this.flow = data;
        }), catchError((err: HttpErrorResponse) => {
          return this.authService.handleGetFlowError(err, 'registration', () => {
            this.flow = undefined;
          })
        }))
        .subscribe({
          next: (data) => {
            if (this.flow?.oauth2_login_request?.challenge) {
              this.loginUrlQueryParams['challenge'] = this.flow?.oauth2_login_challenge;
            }
          },
          error: (err: HttpErrorResponse) => {
            console.log('registration error: ', err);
          }
        })
    );

  }

  onSubmit(values: UpdateRegistrationFlowBody): void {
    // updateFlowIdWithoutRefresh(String(this.flow?.id));
    this.subscription.add(
      this.authService.updateRegistrationFlow(values, String(this.flow?.id), this.flow?.return_to)
        .pipe(catchError((err: HttpErrorResponse) => {
          return this.authService.handleGetFlowError(err, 'registration', () => {
            this.flow = undefined;
          });
        }))
        .subscribe({
          next: () => {
          },
          error: (err: HttpErrorResponse) => {
            // If the previous handler did not catch the error it's most likely a form validation error
            if (err.status === 400) {
              // Yup, it is!
              this.flow = err.error as RegistrationFlow;
              return;
            }

            console.log(err);
            return;
          }
        })
    );
  }

}
